var eventemitter3 = { exports: {} };
export {
  eventemitter3 as __module
};
//# sourceMappingURL=index3.js.map
